<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">开始日期:</div>
                <el-date-picker
                v-model="conditionData.StartTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="item">
                <div class="label">结束日期:</div>
                <el-date-picker
                v-model="conditionData.EndTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="warning" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <!-- <el-tag type="success" style="margin-right:10px">花费时间：{{consumeTime}}</el-tag> -->
                    <!-- <el-button type="primary" icon="el-icon-refresh" size="small" @click="updateNewData()">更新最新数据</el-button> -->
                    <el-button type="success" icon="el-icon-bottom" size="small" @click="getExcel()">导出</el-button>
                </div>
            </div>
            <el-table
                v-loading="loading"
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="550"
                style="width: 100%">
                
                <el-table-column
                prop="companyM"
                label="公司名称"
                align="center"
                width="120"
                >
                </el-table-column>
                <el-table-column
                prop="remarks"
                label="备注"
                align="center"
                width="240"
                >
                </el-table-column>
                <el-table-column
                prop="wwcCaseNumBer"
                label="未完成未开票案件量"
                align="center"
                width="170"
                >
                </el-table-column>
                <el-table-column
                prop="wwcCaseMoney"
                label="未完成未开票金额"
                align="center"
                width="150"
                >
                </el-table-column>
                <el-table-column
                prop="ywcCaseNumBer"
                label="已完成未开票案件量"
                align="center"
                width="165"
                >
                </el-table-column>
                <el-table-column
                prop="yshCaseMoney"
                label="已审核案件金额"
                align="center"
                width="140"
                >
                </el-table-column>
                <el-table-column
                prop="yjaCaseMoney"
                label="已结案待开票金额"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="ywcCaseMoney"
                label="已完成未开票金额"
                align="center"
                width="190"
                >
                </el-table-column>
                <el-table-column
                prop="yhkCaseMoney"
                label="已回款未开票金额"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="ykpnoCaseMoney"
                label="已开票未回款金额"
                align="center"
                width="150"
                >
                </el-table-column>
                <el-table-column
                prop="countMoney"
                label="合计"
                align="center"
                width="160"
                >
                </el-table-column>
                
            </el-table>

            <!-- <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next"
                    :total="totalCount"
                    :current-page="conditionData.pageIndex"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div> -->
        </div>


       
        
    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeS} from '../../../utils/index'
import {businessModuleList} from '../../../assets/selectList/assetsSelectList'
export default {
    name: 'person',
    data () {
        return {
            businessModuleList:businessModuleList,
            isShow:false,
            totalCount:0,
            isUpdateDialog:false,
            updateData:{}, 
            conditionData:{
                businessModule:3,
                StartTime:'',
                EndTime:'',
            },
            tableData:[],
            isAddDialog:false,
            addData:{
                ganden:2,
            },
            loading:false,
            consumeTime:'',
        }
    },
    created(){

    },
    mounted(){
        this.loadingData();
    },
    methods:{
        
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            this.loading = true;
            let res  = await api.getCPAllData(this.conditionData);
            this.loading = false;
            console.log(res);
            this.tableData = res.data.data.resCounts;
            // this.consumeTime = res.data.data.consumeTime;
            // if(this.tableData.length == 0){
            //     this.updateNewData();
            // }
            
        },
        selectData(){
            // this.conditionData.pageIndex = 1;
            this.loadingData();
        },
       
        
        handleCurrentChange(page){
            // this.conditionData.pageIndex = page;
            this.loadingData();
        },
        isUpdateDialogShow(row){
            this.role = row.roleName;
            this.updateData = row;
            this.isUpdateDialog = true;
        },
        // 重置
        reset(){
            this.conditionData = {
                businessModule:5,
                StartTime:'',
                EndTime:'',
            },
            this.loadingData();
        },
        // 弹出新建
        addDialogShow(){
            this.addData={};
            this.role='';
            this.isAddDialog = true;
        },
        
        // 更新数据
        async updateNewData(){
            this.loading = true;
            let res  = await api.getCPAllData({});
            this.loading = false;
            this.tableData = res.data.data.resCounts;
            this.consumeTime = res.data.data.consumeTime;

        },
        async getExcel(){
            let res  = await api.exportLatest(this.conditionData);

        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 8px;
        font-size: 14px;
        .item{
            padding: 7px;
            display: flex;
            align-items: center;
            margin-right: 20px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }
    .dialog{
        display: flex;
        flex-direction: column;
        padding-top: 16px;
        height: 100%;
        // overflow: scroll;
        .item{
            font-size: 14px;
            padding:8px 15px;
            display: flex;
            align-items: center;
            .label{
                width: 120px;
                margin-bottom: 5px;
            }
            .input{
                width: 215px;
                display: flex;
            }
        }
        .btns{
            background-color: #ffffff;
            width: 100%;
            bottom: 0;
            display:flex;
            flex-direction: row-reverse;
            .el-button{
                margin-right: 10px;
            }
        }
    }
</style>
